import { render, staticRenderFns } from "./FundCapitalProject.vue?vue&type=template&id=24a6fc22&scoped=true&"
import script from "./FundCapitalProject.vue?vue&type=script&lang=js&"
export * from "./FundCapitalProject.vue?vue&type=script&lang=js&"
import style0 from "./FundCapitalProject.vue?vue&type=style&index=0&id=24a6fc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6fc22",
  null
  
)

export default component.exports